import Vue from "vue";

let eventBus = new Vue();

let plugin = {
  install(Vue, options = {}) {
    Vue["prototype"].$modal = {
      show(name, state) {
        eventBus.$emit("toggle", name, state);
      },
      hide(name) {
        eventBus.$emit("toggle", name, false);
      }
    }
  }
}

export { eventBus as ModalEventBus, plugin as ModalPlugin };
